import React, { Component } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { startEditExpenseAccount } from '../../../actions/expenseAccountActions';
import PropTypes from 'prop-types';
import ExpenseAccountForm from './ExpenseAccountForm';

export class EditExpenseAccountPage extends Component {

  onFormActionSubmit = (expenseAccount) => {
    this.props.startEditExpenseAccount(expenseAccount.expense_account_id, expenseAccount);
  };

  render() {
    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Edit Expense Account
        </Typography>
        <ExpenseAccountForm
          editMode
          onFormActionSubmit={this.onFormActionSubmit}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
    startEditExpenseAccount: (id, expenseAccount) => dispatch(startEditExpenseAccount(id, expenseAccount)),
});

export default connect(undefined, mapDispatchToProps)(EditExpenseAccountPage);



// WEBPACK FOOTER //
// ./src/components/admin/expenseAccounts/EditExpenseAccountPage.js